<script lang="ts" setup>
/**
 * @usage Accepts and returns a string value containing a distance and units (miles/km)
 * separated by a pipe character, e.g. "123|km".
 * Recieves an InvalidFields enum for displaying erro borders.
 */

import BrandInput from '../../BrandInput.vue';
import BrandButton from '../../BrandButton.vue';
import { InvalidFields } from './types';
import { reactive, watch } from 'vue';
import { useTranslate } from '@/locales/i18n';

const translate = useTranslate();

interface distanceProps {
  value: any;
  invalidFields: InvalidFields;
  placeholder: string;
}

const props = defineProps<distanceProps>();

const emit = defineEmits(['valueUpdated']);

const data = reactive({
  input: props.value.split('|')[0],
  unit: props.value.split('|')[1],
});

const toggleUnits = (unit: string) => {
  data.unit = unit;
  updateValue();
};

watch(
  () => data.input,
  () => updateValue(),
);

function updateValue() {
  const localVal = data.input + '|' + data.unit;
  emit('valueUpdated', localVal);
}
</script>

<template>
  <div class="flex flex-row items-center">
    <div
      :class="
        props.invalidFields === InvalidFields.input || props.invalidFields === InvalidFields.both
          ? 'border-red-600'
          : ''
      "
      class="rounded border border-transparent"
    >
      <BrandInput
        v-model="data.input"
        :placeholder="props.placeholder"
        class="w-24 bg-gray-50 border-gray-300"
        min="0"
        type="number"
      />
    </div>
    <div
      :class="
        props.invalidFields === InvalidFields.units || props.invalidFields === InvalidFields.both
          ? 'border border-red-600'
          : ''
      "
      class="flex ml-4 rounded"
    >
      <BrandButton
        :class="
          data.unit == 'miles'
            ? '!bg-lilac-400 text-white font-bold'
            : 'bg-gray-50 text-black font-normal'
        "
        button-class="w-auto block font-normal rounded-xs rounded-r-none bg-gray-50 border border-gray-300 hover:bg-gray-100"
        @click="toggleUnits('miles')"
      >
        {{ translate('survey.fields.miles') }}
      </BrandButton>
      <BrandButton
        :class="
          data.unit == 'km'
            ? '!bg-lilac-400 text-white font-bold'
            : 'bg-gray-50 text-black font-normal'
        "
        button-class="w-auto block font-normal rounded-xs rounded-l-none bg-gray-50 border border-l-0 border-gray-300 hover:bg-gray-100"
        @click="toggleUnits('km')"
      >
        {{ translate('survey.fields.km') }}
      </BrandButton>
    </div>
  </div>
</template>
